module.exports = __webpack_public_path__ + "img/huaian.1ac6be95.png";